export default __webpack_public_path__ + "static/media/cauliflower.12a15e5f.jpg";